import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD3v8Et4Bfp4PrydwbCauyKARDSNBc7dmg",
  authDomain: "account-book-80de2.firebaseapp.com",
  projectId: "account-book-80de2",
  storageBucket: "account-book-80de2.appspot.com",
  messagingSenderId: "947180564403",
  appId: "1:947180564403:web:f929751b053400bc94e5c6",
  measurementId: "G-VEV9DQHFK2",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
